import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";

import { AteneaModule } from "@atenea-cms";
import { DownloadTypesRoutes } from "./download-types.routes";
import { DownloadTypeListComponent } from "./download-type-list/download-type-list.component";
import { DownloadTypeFormComponent } from "./download-type-form/download-type-form.component";
import { DownloadTypeService, DownloadTypeFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AteneaModule,
    DownloadTypesRoutes,
  ],
  declarations: [DownloadTypeListComponent, DownloadTypeFormComponent],
  providers: [DownloadTypeService, DownloadTypeFormService],
})
export class DownloadTypesModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/download-types/download-types.module.ts